export default __webpack_public_path__ + "6159455.png";